import React from 'react';
import { ScrollView } from 'react-native';
import ManualInputField from './ManualInputField';
import SaveToContacts from './SaveToContacts';
import RecipientInformation from './RecipientInformation';
import { inputTestManual, manual_name } from '../../utils/DictionaryManagementUtils';
import LargeBtnWithFilling from '../SimulatorsComponents/AuxiliaryComponent/ButtonComponent/LargeBtnWithFilling';

//= ========================================================================
const MenuManualRecipient = ({
  globJSON,
  simPlatform,
  manualName,
  subCategoryId,
  isFormFilled,
  toAddContactName,
}) => {
  const { recipient } = globJSON.configurations.services[subCategoryId];
  const manual_recipient = recipient.manual_recipients[manualName];
  return (
    <ScrollView
      style={{
        paddingStart: 17,
        paddingEnd: 17,
        overflow: 'hidden',
      }}
      vertical
      pagingEnabled={false}
      showsVerticalScrollIndicator={false}
      scrollEnabled
    >
      {(Object.keys(manual_recipient.manual_fields_list)
        .filter((manualField) => (manual_recipient.manual_fields_list[manualField]))
        .map((manualField) => {
          const customManualField = manualField === manual_name ? manualName : manualField;
          const showIcon = manualField === manual_name && manual_recipient.enable_recipient_validation;
          const isArrow = globJSON.configurations.general.is_arrow_icon;

          return (
            <ManualInputField
              key={`ManualInputField${manualField}`}
              globJSON={globJSON}
              simPlatform={simPlatform}
              inputKey={manualName}
              subCategoryId={subCategoryId}
              iconGray={isFormFilled}
              categoryText={manual_recipient[manualField]}
              inputText={inputTestManual[customManualField]}
              isFormFilled={isFormFilled}
              showIcon={showIcon}
              isArrow={isArrow}
            />
          );
        })
            )}
      {isFormFilled && (manual_recipient.enable_recipient_validation ? (
        <RecipientInformation
          globJSON={globJSON}
          simPlatform={simPlatform}
          subCategoryId={subCategoryId}
          manualName={manualName}
        />
      )
        : null)}

      {(manual_recipient.save_to_list ? (
        <SaveToContacts
          globJSON={globJSON}
          txt={recipient.save_to_contacts}
          simPlatform={simPlatform}
          isFilled={toAddContactName}
        />
      )
        : null)}

      {(toAddContactName && manual_recipient.save_to_list && manual_recipient.add_contact_name
                && (
                <ManualInputField
                  globJSON={globJSON}
                  simPlatform={simPlatform}
                  inputKey={manualName}
                  subCategoryId={subCategoryId}
                  iconGray={isFormFilled}
                  categoryText={manual_recipient.add_contact_name_str}
                  inputText={inputTestManual.add_contact_name}
                  isFormFilled={isFormFilled}
                />
                )
            )}
      <LargeBtnWithFilling
        globJSON={globJSON}
        simPlatform={simPlatform}
        subCategoryId={subCategoryId}
        inputText={manual_recipient.next}
        disableBtn={!isFormFilled}
        withFlex
      />
    </ScrollView>
  );
};

export default MenuManualRecipient;
